import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import { withLangParam } from '../../utils/language';
import './LanguageSwitch.scss';

const languages = [
    { code: 'de', label: 'DE', flagClass: 'flag-de' },
    { code: 'pl', label: 'PL', flagClass: 'flag-pl' },
    { code: 'en', label: 'EN', flagClass: 'flag-en' },
];

const LanguageSwitch = () => {
    const { i18n } = useTranslation();
    const location = useLocation();
    const history = useHistory();
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    const currentLang =
        languages.find((language) => language.code === i18n.language) ||
        languages[0];

    // the url is the source of truth, LanguageParamSync applies the new language
    const handleSelect = (code) => {
        setIsOpen(false);
        history.replace({
            pathname: location.pathname,
            search: withLangParam(location.search, code),
            hash: location.hash,
            state: location.state,
        });
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target)
            ) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div className="language-switch align-self-start" ref={dropdownRef}>
            <button
                type="button"
                className="language-switch__trigger"
                onClick={() => setIsOpen((open) => !open)}
            >
                <span
                    className={`language-switch__flag ${currentLang.flagClass}`}
                />
                <span className="language-switch__label">
                    {currentLang.label}
                </span>
                <span className="language-switch__chevron" />
            </button>

            {isOpen && (
                <ul className="language-switch__menu">
                    {languages.map((lang) => (
                        <li key={lang.code}>
                            <button
                                type="button"
                                className={`language-switch__option${
                                    lang.code === currentLang.code
                                        ? ' language-switch__option--active'
                                        : ''
                                }`}
                                onClick={() => handleSelect(lang.code)}
                            >
                                <span
                                    className={`language-switch__flag ${lang.flagClass}`}
                                />
                                <span className="language-switch__option-label">
                                    {lang.label}
                                </span>
                            </button>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default LanguageSwitch;
